// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_dismissAlertsByGroupV5(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["AlertsGroupDismissed"]);
}

let variablesConverter = {"dismissAlertsByGroupInput":{},"__root":{"input":{"r":"dismissAlertsByGroupInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"dismissAlertsByGroupV5":{"u":"response_dismissAlertsByGroupV5"}}};

let wrapResponseConverterMap = {
  response_dismissAlertsByGroupV5: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"dismissAlertsByGroupV5":{"u":"response_dismissAlertsByGroupV5"}}};

let responseConverterMap = {
  response_dismissAlertsByGroupV5: unwrap_response_dismissAlertsByGroupV5
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

function alertGroup_decode($$enum) {
  if ($$enum === "CONVERSATIONS" || $$enum === "MATCHES") {
    return $$enum;
  }
}

let alertGroup_fromString = alertGroup_decode;

let Utils = {
  alertGroup_decode: alertGroup_decode,
  alertGroup_fromString: alertGroup_fromString
};

let node = ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedAlertNodeIds",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AlertsDropdownDismissAlertGroupMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "dismissAlertsByGroupV5",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/)
            ],
            "type": "AlertsGroupDismissed",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AlertsDropdownDismissAlertGroupMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "dismissAlertsByGroupV5",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteEdge",
                "key": "",
                "kind": "ScalarHandle",
                "name": "deletedAlertNodeIds",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  }
                ]
              }
            ],
            "type": "AlertsGroupDismissed",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "96111d07f5e56809f9233501f2984e2a",
    "id": null,
    "metadata": {},
    "name": "AlertsDropdownDismissAlertGroupMutation",
    "operationKind": "mutation",
    "text": "mutation AlertsDropdownDismissAlertGroupMutation(\n  $input: DismissAlertsByGroupInput!\n) {\n  dismissAlertsByGroupV5(input: $input) {\n    __typename\n    ... on AlertsGroupDismissed {\n      deletedAlertNodeIds\n    }\n  }\n}\n"
  }
};
})());

let wrap_response_dismissAlertsByGroupV5 = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_dismissAlertsByGroupV5 = unwrap_response_dismissAlertsByGroupV5;
exports.wrap_response_dismissAlertsByGroupV5 = wrap_response_dismissAlertsByGroupV5;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
